export default __webpack_public_path__ + "726c5f70befb4dcaf41e5a29f3faa65e.png";